import React from 'react';
import { Loader2 } from 'lucide-react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useGlobalStates } from '@/hooks/useGlobalStates';

interface StateSelectProps {
  value: string;
  onChange: (value: string) => void;
  countryCode?: string;
  placeholder?: string;
  disabled?: boolean;
}

const StateSelect: React.FC<StateSelectProps> = ({
  value,
  onChange,
  countryCode = 'BR',
  placeholder = "Selecione o estado",
  disabled = false
}) => {
  const { data: states = [], isLoading, error } = useGlobalStates(countryCode);

  // Don't render if country has no states
  if (!isLoading && states.length === 0) {
    return null;
  }

  const getPlaceholder = () => {
    if (isLoading) return 'Carregando...';
    if (error) return 'Erro ao carregar';
    return placeholder;
  };

  return (
    <Select 
      value={value} 
      onValueChange={onChange} 
      disabled={disabled || isLoading || !!error}
    >
      <SelectTrigger className="bg-white/5 border-white/20 text-white placeholder:text-white/40 focus:border-luxury-pinkBright/50">
        {isLoading ? (
          <div className="flex items-center gap-2">
            <Loader2 className="h-4 w-4 animate-spin" />
            <span className="text-white/40">Carregando...</span>
          </div>
        ) : (
          <SelectValue placeholder={getPlaceholder()} />
        )}
      </SelectTrigger>
      <SelectContent className="bg-gray-900 border-white/20 max-h-[300px]">
        {states.map((state) => (
          <SelectItem
            key={state.code}
            value={state.code}
            className="text-white hover:bg-white/10 focus:bg-white/10 focus:text-white cursor-pointer"
          >
            {state.name} ({state.code})
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default StateSelect;
